import * as React from 'react';
import { ButtonGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';

interface IProps {
    zoom: (zoomAmount: number) => void;
    restoreCanvasPosition: () => void;
}

const style = {
    zIndex: 1,
    position: 'absolute',
    width: '20%',
    paddingTop: 10,
    paddingRight: 10,
    right: 10
};

const ZoomButtons = (props: IProps) => {
    return (
        <div style={style}>
            <ButtonGroup className="pull-right">
                <Button bsStyle="success" bsSize="sm" onClick={() => props.zoom(200)}>
                    +
                </Button>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="restore-zoom">
                            {Translate('plans/annotation/toolbar/restore-zoom-pan')}
                        </Tooltip>
                    }
                >
                    <Button bsStyle="info" bsSize="sm" onClick={props.restoreCanvasPosition}>
                        1:1
                    </Button>
                </OverlayTrigger>
                <Button bsStyle="warning" bsSize="sm" onClick={() => props.zoom(-200)}>
                    -
                </Button>
            </ButtonGroup>
        </div>
    );
};

export default ZoomButtons;
